import { ref, computed } from 'vue';
import { createSharedComposable } from '@vueuse/core';

export interface LastProjectInfo {
    id: string;
    title: string;
    is_owner?: boolean;
    work_type?: string;
}

export const useLastProjectInfo = createSharedComposable(() => {
    const lastProjectInfo = ref<LastProjectInfo | null>(null);

    const setProjectInfo = (info: LastProjectInfo) => {
        lastProjectInfo.value = info;
    };

    const clearProjectInfo = () => {
        lastProjectInfo.value = null;
    };

    const currentReturnAgentType = computed(() => {
        if (!lastProjectInfo.value?.work_type) {
            return false;
        }

        return ({
            '00': false,
            '01': 'drafting',
            '10': 'oar',
            '11': false,
            '20': 'disclosure',
        })[ lastProjectInfo.value.work_type ] || false;
    });

    return {
        lastProjectInfo,
        setProjectInfo,
        clearProjectInfo,
        currentReturnAgentType,
    };
});
